<template lang="html">

  <div class="wrapper -internacional">

    <div class="encabezado">

      <div class="container column-start">
        <div class="contenedor-logo">
          <router-link to="/">
            <img src="/static/img/UFV-logo.png" alt="Logo UFV">
          </router-link>
        </div>
        <h1>Internacional</h1>

      </div>

    </div>

    <div class="migas">
      <div class="container">
        <nav class="row-start">
          <router-link to="/">Home</router-link>
          <router-link :to="$t('enlaces.alumnos')">Alumnos y alumni</router-link>
          <router-link :to="$t('enlaces.internacional')">Internacional</router-link>
        </nav>
      </div>
    </div>



    <section class="accesos -small row-center container ais">

      <article class="column-center ofertas-practicas">
        <div>
          <h2>Orientación</h2>
          <p>Accede a la información y recomendaciones que te ayudarán a preparar tu experiencia laboral.</p>
        </div>
        <router-link :to="$t('enlaces.buscadorrecursosinternacional') + '/orientacion'"
          class="btn -skull -white -azul">Saber más</router-link>
        <router-link :to="$t('enlaces.buscadorrecursosinternacional') + '/orientacion'"
          class="enlace-cover"></router-link>
      </article>
      <article class="column-center informacion-paises">
        <div>
          <h2>Programas</h2>
          <p>Conoce las convocatorias y programas que te permitirán realizar prácticas o acceder a un empleo
            internacional.</p>
        </div>
        <router-link :to="$t('enlaces.buscadorrecursosinternacional') + '/programas'"
          class="btn -skull -white -azul">Saber más</router-link>
        <router-link :to="$t('enlaces.buscadorrecursosinternacional') + '/programas'" class="enlace-cover"></router-link>
      </article>
      <article class="column-center programas">
        <div>
          <h2>Recursos</h2>
          <p>Te facilitamos información actualizada sobre diferentes recursos que te serán útiles en la búsqueda de
            oportunidades internacionales.</p>
        </div>
        <router-link :to="$t('enlaces.buscadorrecursosinternacional') + '/recursos'" class="btn -skull -white -azul">Saber
          más</router-link>
        <router-link :to="$t('enlaces.buscadorrecursosinternacional') + '/recursos'" class="enlace-cover"></router-link>
      </article>
      <article class="column-center otros">
        <div>
          <h2>Más información</h2>
        </div>
        <router-link :to="$t('enlaces.buscadorrecursosinternacional') + '/more-info'"
              class="btn -skull -white -azul">Saber más</router-link>
            <router-link :to="$t('enlaces.buscadorrecursosinternacional') + '/more-info'"
              class="enlace-cover"></router-link>
      </article>


    </section>
   

    <div class="contenedor-boton buscador">
      <h2 class="big-bold-title -blue -center">Buscador de recursos</h2>
      <p class="texto-buscador">Ponemos a tu disposición documentos, testimonios y artículos de tu interés.<br> Accede
        para encontrar toda la información</p>
      <router-link :to="$t('enlaces.buscadorrecursosinternacional')" class="btn -skull">Acceder al
        buscador</router-link>
    </div>


    <destacados :position="4"></destacados>




    <section class="conectados-home">


      <div class="container row-between ais">


        <img src="/static/img/imagen-conectados.svg" class="imagen-conectados" alt="Imagen Conectados">


        <div class="main-card">
          <img src="/static/img/flecha.svg" alt="Ver más" :show="showsecondarycard" @click="showsecondarycard = false">
          <p>¿Recuerdas tus primeros pasos profesionales? Seguro que sentiste algunos miedos, inseguridades o
            necesitaste orientación y acompañamiento. Tu trayectoria, experiencia y conocimientos son muy valiosos para
            quien ahora comienza.</p>
          <p>¿Quieres apoyar a los jóvenes talentos?</p>
          <div class="boton-redondo"></div>

          <router-link :to="$t('enlaces.conectados') + '/profesional'" class="btn -skull -white">Conecta</router-link>
        </div>

        <div class="secondary-card" :show="showsecondarycard" @click="showsecondarycard = !showsecondarycard">
          <img src="/static/img/flecha.svg" alt="Ver más" :show="!showsecondarycard">
          <p>Conocer en profundidad te ayuda a tomar decisiones. Si tienes dudas sobre un sector, industria, empresa. Te
            enfrentas a un proceso de selección y quieres información para prepararte bien... ante cualquier duda en las
            decisiones sobre tu carrera profesional, te ponemos en contacto con quien puede ayudarte.</p>
          <router-link :to="$t('enlaces.conectados') + '/alumno'" class="btn -skull -white">Conecta</router-link>
        </div>
      </div>

    </section>

    <al-dia-banner :position="4"></al-dia-banner>

  </div>

</template>

<script lang="js">

import bannerconectados from '@/components/parts/banner-conectados';
import aldiabanner from '@/components/parts/al-dia-banner';

import aldia from '@/components/view-parts/home/al-dia';

import destacados from '@/components/parts/destacados';

import filtro from '@/components/parts/filtro'

import Slick from 'vue-slick';

import { mapGetters } from 'vuex';

export default {
  name: 'internacional',
  data() {
    return {
      showproyectoformativo: false,
      showFiltro: false,
      filter: '',
      page: 1,
      slickOptions: {
        slidesToShow: 1,
        dots: false,
        arrows: true,
        adaptiveHeight: false,
        autoplay: true,
        autoplaySpeed: 3000,
        variableWidth: false
      },
    }
  },
  computed: {
    ...mapGetters({
      recursos: 'getRecursosInternacional'
    }),
    elements() {

      let elements = new Array();

      if (!!this.filter) {

        elements = this.recursos;
        //AREAS
        if (!!this.filter.area) {
          elements = elements.filter(e => (e.area.some(a => a.slug == this.filter.area)));
        }

        if (!!this.filter.categoria) {
          elements = elements.filter(e => (e.categoria.some(a => a.slug == this.filter.categoria)));
        }

        if (!!this.filter.titulos) {
          elements = elements.filter(e => (e.titulos.some(a => a.slug == this.filter.titulos.slug)));
        }

        if (!!this.filter.tags) {
          elements = elements.filter(e => {
            let existe = false;

            if (!!e.tags) {
              e.tags.forEach(t => {
                (this.filter.tags.some(tag => tag == t)) ? existe = true : null;
              })
            }

            return existe;

          });
        }

        if (!!this.filter.search) {

          let searchIn = ['titulo', 'entradilla'];

          elements = elements.filter(element => {

            let can = false;

            searchIn.forEach(where => {
              (element[where].toLowerCase().includes(this.filter.search.toLowerCase())) ? can = true : '';
            });

            return (can) ? element : '';
          });

        }

        if (!!this.filter.fecha) {
          let actual = new Date().getTime();
          const SEMANAVAL = 604800000;
          let limit;
          switch (this.filter.fecha) {
            case 'day':
              limit = (actual - SEMANAVAL);
              break;
            case 'month':
              limit = (actual - SEMANAVAL * 4);
              break;
            case 'ever':
              limit = 0;
              break;
          }

          elements = elements.filter(o => {
            let fecha = new Date(o.fecha.full).getTime();
            return (fecha >= limit);
          });


        }

      } else {
        elements = this.recursos;
      }

      return elements;
    },
    perpage() {
      return 9;
    },
    pages() {
      return Math.ceil(this.elements.length / this.perpage);
    },

  },
  methods: {
    prev() {
      if (this.page > 1) {
        this.page--;
      }
    },
    next() {
      if (this.page < this.pages) {
        this.page++;
      }
    },
    setPage(page) {
      this.page = page;
    },
    setArea(area) {
      $('html,body').animate({ scrollTop: $(".filtro").offset().top - 100 }, 500, 'swing');
      this.$refs.filtro.setArea(area)
    }
  },
  components: {
    'banner-conectados': bannerconectados,
    'al-dia-banner': aldiabanner,
    'al-dia': aldia,
    'destacados': destacados,
    'filtro': filtro,
    Slick
  },
  filters: {
    stringcategoria(value) {
      let cats = new Array();
      value.forEach(v => {
        cats.push(v.nombre);
      })
      let last = cats.pop();
      return cats.join(", ") + ' y ' + last;
    }
  }
}
</script>

<style scoped lang="scss">
.accesos-home {
  article {
    padding: 65px 20px;
    justify-content: flex-start;

    h2 {
      min-height: 72px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    /*
      &:nth-child(1) {
        background: url(/static/img/acceso-internacional-1.jpg) center/cover no-repeat;
      }

      &:nth-child(2) {
        background: url(/static/img/acceso-internacional-2.jpg) center/cover no-repeat;
      }

      &:nth-child(3) {
        background: url(/static/img/acceso-internacional-3.jpg) center/cover no-repeat;
      }*/
  }
}


@media screen and (max-width: 1400px) {
  .accesos article {
    padding: 50px 20px;
  }
}

@media screen and (max-width: 900px) {
  .accesos article {
    padding: 100px 20px;
  }
}

@media screen and (max-width: 500px) {
  .accesos article {
    padding: 100px 20px;
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/views/alumni-internacional.vue